import { Stack } from '@mui/material'
import isNil from 'lodash/isNil'
import { Request } from '@omnea-app/requests/requestsHttpClient'

const getPriorityIconColor = (priority: Request['derivedFields']['priority'] | undefined) => {
  const lowPriorityValues = ['LOWEST', 'LOW']
  const highPriorityValues = ['HIGHEST', 'HIGH']
  if (isNil(priority)) return 'bg.neutral.muted' // Neutral Grey
  if (lowPriorityValues.includes(priority)) return 'purple.500' // Purple
  if (highPriorityValues.includes(priority)) return 'amber.900' // Red
  return 'orange.500' // Orange
}

interface Props {
  priority?: Request['derivedFields']['priority']
}

export const RequestPriorityIcon = ({ priority }: Props) => {
  const color = getPriorityIconColor(priority)

  const iconColor = color === 'bg.neutral.muted' ? 'fg.subtle' : color

  return (
    <Stack
      sx={{
        bgcolor: color,
        borderRadius: 8,
        color: iconColor,
        height: 18,
        width: 3,
      }}
    />
  )
}
